module.exports = __webpack_public_path__ + "ae6d32bca5522274340778c82c84298e.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/age-gate-bg-320.jpg
// module id = 167
// module chunks = 0